export default __webpack_public_path__ + "static/media/gradient_candle_left_desktop.95d9e6e1.png";